"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_20_0_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * Migrate to 20.0.0
 *
 * The property `laengeUeberstandLock` has been added to `Leitung`.
 *
 *  =>
 *
 *  set this property according to the state of the 3 different laenge properties:
 *  - leitungslaenge
 *  - ueberstandFestpunkt
 *  - ueberstandMitnehmer
 */
const migration_20_0_0 = (json) => {
    if (json.Leitungen) {
        json.Leitungen.forEach((leitung) => {
            echain_shared_articles_1.LeitungslaengeUeberstandLockUtil.update(leitung);
        });
    }
    return json;
};
exports.migration_20_0_0 = migration_20_0_0;
//# sourceMappingURL=migration_20_0_0.js.map